(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tft-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var root = document.querySelector('[data-tft-popup]');
      if (!root || root.dataset.tftPopupInit) return;
      root.dataset.tftPopupInit = '1';

      // Portal to <body> so z-index/scrim sit above the sticky header and
      // backdrop-filter samples the whole page (escapes the section wrapper's
      // stacking context).
      if (root.parentNode !== document.body) document.body.appendChild(root);

      var DESIGN_MODE = !!(window.Shopify && Shopify.designMode);
      var KEY_DISMISSED = 'tft_popup_dismissed_at';
      var KEY_SUBSCRIBED = 'tft_popup_subscribed';
      var freqDays = parseInt(root.dataset.frequencyDays, 10) || 30;
      var delay = parseInt(root.dataset.delay, 10) || 5000;
      var card = root.querySelector('.tft-popup__card');
      var lastFocus = null;
      var successLocked = false; // once the code is shown, only the X closes it

      function store(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
      function save(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

      function suppressedByPath() {
        var p = window.location.pathname;
        return /\/(cart|account|challenge|password|checkouts?)\b/.test(p);
      }

      function shouldShow() {
        if (DESIGN_MODE) return true;
        if (suppressedByPath()) return false;
        if (store(KEY_SUBSCRIBED) === '1') return false;
        var d = parseInt(store(KEY_DISMISSED), 10);
        if (d && (Date.now() - d) < freqDays * 86400000) return false;
        return true;
      }

      function focusables() {
        return card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
      }

      function onKeydown(e) {
        if (e.key === 'Escape') { if (!successLocked) close(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      function showModal(focusEmail) {
        if (root.hidden) {
          lastFocus = document.activeElement;
          root.hidden = false;
          void root.offsetWidth; // force reflow so the transition runs
        }
        root.classList.add('is-open');
        document.addEventListener('keydown', onKeydown);
        if (focusEmail) {
          var email = root.querySelector('input[type="email"]');
          if (email && !DESIGN_MODE) { setTimeout(function () { email.focus(); }, 60); }
        }
      }
      function open() { showModal(true); }

      function close() {
        successLocked = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKeydown);
        if (!DESIGN_MODE) save(KEY_DISMISSED, String(Date.now()));
        setTimeout(function () { root.hidden = true; }, 380);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      // The X always closes. The scrim closes ONLY before the code is shown —
      // once we're on the success state, an accidental backdrop tap must not
      // dismiss it (the user needs time to copy the code).
      var xBtn = root.querySelector('.tft-popup__close');
      if (xBtn) xBtn.addEventListener('click', close);
      var scrimEl = root.querySelector('.tft-popup__scrim');
      if (scrimEl) scrimEl.addEventListener('click', function () { if (!successLocked) close(); });

      // Reveal the discount code. Works whether the modal is already open
      // (its own form) or closed (triggered by another newsletter form).
      function revealSuccess() {
        showModal(false);
        var f = root.querySelector('[data-popup-form-state]');
        var s = root.querySelector('[data-popup-success-state]');
        if (f) f.hidden = true;
        if (s) s.hidden = false;
        successLocked = true;
        save(KEY_SUBSCRIBED, '1');
        var cp = root.querySelector('[data-popup-copy]');
        if (cp && !DESIGN_MODE) setTimeout(function () { cp.focus(); }, 80);
      }

      // Background capture (never gates the on-screen reward).
      function postCapture(f) {
        try {
          fetch(f.action, { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json' } })
            .then(function () {}).catch(function () {});
        } catch (e) {}
      }

      // Copy-to-clipboard for the code.
      var copyBtn = root.querySelector('[data-popup-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var codeEl = root.querySelector('[data-popup-code]');
          var code = codeEl ? codeEl.textContent.trim() : '';
          var label = root.querySelector('[data-popup-copy-label]');
          // Try BOTH copy methods (belt and braces). Don't gate the UI feedback
          // on a promise — navigator.clipboard.writeText can hang/never settle,
          // which would leave the user with no confirmation.
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code).catch(function () {});
            }
          } catch (e) {}
          try {
            var ta = document.createElement('textarea');
            ta.value = code; ta.setAttribute('readonly', '');
            ta.style.position = 'absolute'; ta.style.left = '-9999px';
            document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta);
          } catch (e) {}
          // Always confirm.
          copyBtn.classList.add('is-copied');
          if (label) label.textContent = 'Copied';
          setTimeout(function () { copyBtn.classList.remove('is-copied'); if (label) label.textContent = 'Copy'; }, 1800);
        });
      }

      // The pop-up's own form. The submit control is type="button", so the form
      // can NEVER navigate natively — a native submit was reloading the page
      // (?customer_posted=true) and wiping the code within ~2s. Everything routes
      // through doPopupSubmit; no reliance on preventDefault for the happy path.
      var form = root.querySelector('form');
      function doPopupSubmit() {
        if (successLocked) return; // already revealed
        var hp = form.querySelector('.tft-popup__hp');
        if (hp && hp.value) { revealSuccess(); return; } // bot
        if (!form.checkValidity()) { form.reportValidity(); return; }
        postCapture(form);
        revealSuccess();
      }
      if (form) {
        var subBtn = form.querySelector('.tft-popup__submit');
        if (subBtn) subBtn.addEventListener('click', doPopupSubmit);
        var emailInput = form.querySelector('input[type="email"]');
        if (emailInput) emailInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); doPopupSubmit(); }
        });
        // Belt-and-braces: block any native submit (e.g. implicit Enter submit).
        form.addEventListener('submit', function (e) { e.preventDefault(); doPopupSubmit(); });
      }

      // Same flow for every OTHER newsletter form on the site (footer, shop,
      // banner, etc.) — any customer form tagged "newsletter". On submit we
      // capture in the background and open this modal straight to the code.
      var seen = [];
      Array.prototype.forEach.call(document.querySelectorAll('input[name="contact[tags]"]'), function (inp) {
        if ((inp.value || '').toLowerCase().indexOf('newsletter') === -1) return;
        var f = inp.closest('form');
        if (!f || root.contains(f) || seen.indexOf(f) !== -1) return; // skip our own / dupes
        seen.push(f);
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          var em = f.querySelector('input[type="email"]');
          if (em && !em.checkValidity()) { em.reportValidity(); return; }
          var sb = f.querySelector('[type="submit"]');
          if (sb) sb.disabled = true;
          postCapture(f);
          revealSuccess();
          if (sb) setTimeout(function () { sb.disabled = false; }, 1000);
        });
      });

      if (DESIGN_MODE) {
        open();
      } else if (shouldShow()) {
        setTimeout(open, delay);
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tft-treatment-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.tft-tmenu');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tmenu-tab]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.tft-tmenu__row'));
    var countEl = root.querySelector('[data-tmenu-count]');

    function apply(group) {
      var n = 0;
      rows.forEach(function (r) {
        var match = (group === 'all' || r.getAttribute('data-group') === group);
        r.hidden = !match;
        if (match) n++;
      });
      if (countEl) countEl.textContent = n + (n === 1 ? ' treatment' : ' treatments');
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        apply(tab.getAttribute('data-tmenu-tab'));
      });
    });
    apply('all');

    // read more / less
    root.querySelectorAll('[data-tmenu-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var desc = btn.parentNode.querySelector('.tft-tmenu__desc');
        if (!desc) return;
        var open = !desc.hidden;
        desc.hidden = open;
        btn.textContent = open ? 'Read more' : 'Read less';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
